export const disableCountConfig = [
    //p2p.events, payment.events, payout.events, callbacks, p2p.instance, payout.instance, payment.instance, payment_orders, payout_orders
    'p2pEvents',
    'paymentEvents',
    'payoutEvents',
    'urlCallbacks',
    'p2pInstances',
    'payoutInstances',
    'paymentInstances',
    'paymentOrders',
    'payoutOrders',
];
export function isCountDisabledFor(controllerName) {
    return disableCountConfig.includes(controllerName);
}